export interface DecodedImageLoad<TValidation, TBitmap> {
  validation: TValidation
  bitmap: TBitmap | null
}

interface DecodeValidatedImageOptions<TValidation, TBitmap> {
  validate: () => Promise<TValidation>
  isRejected: (validation: TValidation) => boolean
  onValidationSuccess?: () => void
  decode: () => Promise<TBitmap>
  isCurrent: () => boolean
}

/**
 * Validation cannot cancel a request that was reset, replaced, or unmounted
 * while it was pending. Check its generation immediately before crossing into
 * the browser's non-cancellable native decode.
 */
export async function decodeValidatedImage<TValidation, TBitmap>({
  validate,
  isRejected,
  onValidationSuccess,
  decode,
  isCurrent,
}: DecodeValidatedImageOptions<TValidation, TBitmap>): Promise<DecodedImageLoad<TValidation, TBitmap> | null> {
  const validation = await validate()
  if (!isCurrent()) return null

  if (!isRejected(validation)) onValidationSuccess?.()

  return {
    validation,
    bitmap: isRejected(validation) ? null : await decode(),
  }
}
